import React           from 'react';
import ScoreUnit       from './ScoreUnit';

import { scoreType }   from '../../types'
import colors          from '../../utils/colors';
import { makeStyles }  from '@material-ui/core/styles';



const useStyles = makeStyles(() => ({
    root: {
        position:        'absolute',
        top:             200,
        backgroundColor: '#FFF',
        overflowY:       'scroll',
        overflowX:       'hidden',
        borderTop:       '1px solid #DDD',
        '&::-webkit-scrollbar': {
            width: '0.5em',
        },
        '&::-webkit-scrollbar-thumb': {
            backgroundColor: colors.dark,
            borderRadius:    10
        }
    },
    table: {
        display:         'flex',
        marginTop:       10,
        marginLeft:      '1%',
        width:           '98%',
        alignItems:      'center',
        justifyContent:  'center',
        flexFlow:        'column',
    },
    unit: {
        //paddingTop:      1,
        //paddingBottom:   1,
        width:           '100%',
        display:         'flex',
        flex:            1,
        alignItems:      'center',
        justifyContent:  'center',
    }
}))


type ScorePageProps = {
    size:       number[];
    navbarSize: number;
    scores:     scoreType[];
    lang:       string;
    wideScreen: boolean;
}
const ScorePage: React.FC<ScorePageProps> = ({ 
    size,
    navbarSize,
    lang,
    wideScreen,
    scores
}) => {

  const classes = useStyles();

  const [width, height ] = React.useMemo(() => {
       return [
           wideScreen ? size[0] - navbarSize : size[0],
           size[1] - 200
        ]
  },[size, navbarSize, wideScreen])

  return (
    <div 
       className = { classes.root }
       style     = {{
           height: height,
           width:  width
       }}
    >
         <div className = { classes.table }>
             {
                 scores.map((val, ind) => {
                     return(
                         <div
                            key       = { `score^${ ind }` }
                            className = { classes.unit }
                            dir       = 'rtl'
                            style     = {{
                                backgroundColor: ind%2 ? '#FFF' : '#EEF'
                            }}
                         >
                            <div style = {{ width: 150 }}>
                                { val.author }
                            </div>
                            {/* <div style = {{ width: 60 }}>
                                { val.grades }
                            </div> */}
                            <div style = {{ width: 60 }}>
                                { `${ val.correct }%` }
                            </div>
                            <ScoreUnit
                               score      = { val.scores }
                               myIndex    = { ind }
                            />
                         </div>
                     )
                 })
             }
         </div>
    </div>
  );
}




export default ScorePage;
